export default __webpack_public_path__ + "static/media/photo--sm--robleh.ad97e25f.jpg";